export default __webpack_public_path__ + "static/goalsImg-49b3f516e48d92f037b089c2a525e28a.svg";